// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__STYHV","topBottomGutter":"Layout_topBottomGutter__3y8MU"};